import { h } from 'preact';
import Control from '../control';

type Props = {
  id: string;
  children: h.JSX.Element | string;
  onClick?: (e: MouseEvent) => void;
  onTouchStart?: (e: TouchEvent) => void;
  fontSize?: number;
  controlStyle: {
    backgroundColor?: string;
    backgroundOpacity?: number;
    labelColor?: string;
    labelOpacity?: number;
  };
  style: h.JSX.CSSProperties;
  isInterstitialAdUnit?: boolean;
};

export default function CustomizedControl({
  children,
  style = {},
  id,
  fontSize,
  onTouchStart = () => {},
  onClick = () => {},
  controlStyle = {},
  isInterstitialAdUnit = true
}: Props) {
  return (
    <Control
      style={style}
      id={id}
      onTouchStart={onTouchStart}
      onClick={onClick}
      backgroundColor={controlStyle.backgroundColor}
      backgroundOpacity={controlStyle.backgroundOpacity}
      labelColor={controlStyle.labelColor}
      labelOpacity={controlStyle.labelOpacity}
      fontSize={fontSize}
      isInterstitialAdUnit={isInterstitialAdUnit}
    >
      <div>{children}</div>
    </Control>
  );
}
